export const INDICADOR_FACTURACION_NO_FACTURABLE = 0;
export const INDICADOR_FACTURACION_ITBIS_TASA_1 = 1;
export const INDICADOR_FACTURACION_ITBIS_TASA_2 = 2;
export const INDICADOR_FACTURACION_ITBIS_TASA_3 = 3;
export const INDICADOR_FACTURACION_ITBIS_EXENTO = 4;
export const INDICADOR_FACTURACION_NO_FACTURABLE_LABEL = "No Facturable";
export const INDICADOR_FACTURACION_ITBIS_TASA_1_LABEL = "ITBIS 18%";
export const INDICADOR_FACTURACION_ITBIS_TASA_2_LABEL = "ITBIS 16%";
export const INDICADOR_FACTURACION_ITBIS_TASA_3_LABEL = "ITBIS 0%";
export const INDICADOR_FACTURACION_ITBIS_EXENTO_LABEL = "Exento";

export const ITEM_INDICADOR_BIEN = 1;
export const ITEM_INDICADOR_SERVICIO = 2;
export const ITEM_INDICADOR_BIEN_LABEL = "Bien";
export const ITEM_INDICADOR_SERVICIO_LABEL = "Servicio";

const ESTATUS_COMPROBANTE_ACEPTADO = "A";
const ESTATUS_COMPROBANTE_ACEPTADO_CONDICIONAL = "C";
const ESTATUS_COMPROBANTE_RECHAZADO = "R";
const ESTATUS_COMPROBANTE_EN_PROCESO = "P";
const ESTATUS_COMPROBANTE_CONTINGENCIA_LIGERA = "L";
const ESTATUS_COMPROBANTE_ACEPTADO_LABEL = "Aceptado";
const ESTATUS_COMPROBANTE_ACEPTADO_CONDICIONAL_LABEL = "Aceptado Condicional";
const ESTATUS_COMPROBANTE_RECHAZADO_LABEL = "Rechazado";
const ESTATUS_COMPROBANTE_EN_PROCESO_LABEL = "En Proceso";
const ESTATUS_COMPROBANTE_CONTINGENCIA_LIGERA_LABEL = "Emitido Contingencia";


export const TIPO_COMPROBANTE_FACTURA_CREDITO_FISCAL = "31";
export const TIPO_COMPROBANTE_FACTURA_CONSUMO = "32";
export const TIPO_COMPROBANTE_NOTA_DEBITO = "33";
export const TIPO_COMPROBANTE_NOTA_CREDITO = "34";
export const TIPO_COMPROBANTE_COMPRAS = "41";
export const TIPO_COMPROBANTE_GASTO_MENOR = "43";
export const TIPO_COMPROBANTE_REGIMEN_ESPECIAL = "44";
export const TIPO_COMPROBANTE_GUBERNAMENTAL = "45";
export const TIPO_COMPROBANTE_EXPORTACIONES = "46";
export const TIPO_COMPROBANTE_PAGOS_EXTERIOR = "47";
const TIPO_COMPROBANTE_FACTURA_CREDITO_FISCAL_LABEL = "Crédito Fiscal";
const TIPO_COMPROBANTE_FACTURA_CONSUMO_LABEL = "Factura de Consumo";
const TIPO_COMPROBANTE_NOTA_DEBITO_LABEL = "Nota de Débito";
const TIPO_COMPROBANTE_NOTA_CREDITO_LABEL = "Nota de Crédito";
const TIPO_COMPROBANTE_COMPRAS_LABEL = "Compras";
const TIPO_COMPROBANTE_GASTO_MENOR_LABEL = "Gastos Menores";
const TIPO_COMPROBANTE_REGIMEN_ESPECIAL_LABEL = "Régimen Especial";
const TIPO_COMPROBANTE_GUBERNAMENTAL_LABEL = "Gubernamentales";
const TIPO_COMPROBANTE_EXPORTACIONES_LABEL = "Exportaciones";
const TIPO_COMPROBANTE_PAGOS_EXTERIOR_LABEL = "Pagos al Exterior";

const TIPO_INGRESOS_OPERACIONES = "01";
const TIPO_INGRESOS_FINANCIEROS = "02";
const TIPO_INGRESOS_EXTRAORDINARIOS = "03";
const TIPO_INGRESOS_ARRENDAMIENTOS = "04";
const TIPO_INGRESOS_VENTA_ACTIVO = "05";
const TIPO_INGRESOS_OTROS = "06";
const TIPO_INGRESOS_OPERACIONES_LABEL = "Ingresos por operaciones";
const TIPO_INGRESOS_FINANCIEROS_LABEL = " Ingresos Financieros";
const TIPO_INGRESOS_EXTRAORDINARIOS_LABEL = "Ingresos Extraordinarios";
const TIPO_INGRESOS_ARRENDAMIENTOS_LABEL = " Ingresos por Arrendamientos";
const TIPO_INGRESOS_VENTA_ACTIVO_LABEL = "Ingresos por Venta de Activo Depreciable";
const TIPO_INGRESOS_OTROS_LABEL = "Otros Ingresos";

const TIPO_PAGO_CONTADO = "1";
export const TIPO_PAGO_CREDITO = "2";
const TIPO_PAGO_GRATUITO = "3";
const TIPO_PAGO_CONTADO_LABEL = "Contado";
const TIPO_PAGO_CREDITO_LABEL = "Crédito";
const TIPO_PAGO_GRATUITO_LABEL = "Gratuito";

export const MONEDA_PESO_DOMINICANO_ISO = "DOP";
const MONEDA_DOLAR_ISO = "USD";
const MONEDA_EURO_ISO = "EUR";
const MONEDA_PESO_MEXICANO_ISO = "MXN";
const MONEDA_PESO_COLOMBIANO_ISO = "COP";
const MONEDA_REAL_BRASILENO_ISO = "BRL";
const MONEDA_DOLAR_CANADIENSE_ISO = "CAD";
const MONEDA_FRANCO_SUIZO_ISO = "CHF";
const MONEDA_YUAN_CHINO_ISO = "CHY";
const MONEDA_DERECHO_ESPECIAL_GIRO_ISO = "XDR";
const MONEDA_CORONA_DANESA_ISO = "DKK";
const MONEDA_LIBRA_ESTERLINA_ISO = "GBP";
const MONEDA_YEN_JAPONES_ISO = "JPY";
const MONEDA_CORONA_NORUEGA_ISO = "NOK";
const MONEDA_LIBRA_ESCOCESA_ISO = "SCP";
const MONEDA_CORONA_SUECA_ISO = "SEK";
const MONEDA_BOLIVAR_FUERTE_VENEZOLANO_ISO = "VEF";
const MONEDA_GURDA_HAITIANA_ISO = "HTG";
const MONEDA_PESO_DOMINICANO_ISO_LABEL = "Peso Dominicano";
const MONEDA_DOLAR_ISO_LABEL = "Dólar Estadounidense";
const MONEDA_EURO_ISO_LABEL = "Euro";
const MONEDA_PESO_MEXICANO_ISO_LABEL = "Peso Mexicano";
const MONEDA_PESO_COLOMBIANO_ISO_LABEL = "Peso Colombiano";
const MONEDA_REAL_BRASILENO_ISO_LABEL = "Real Brasileño";
const MONEDA_DOLAR_CANADIENSE_ISO_LABEL = "Dólar Canadiense";
const MONEDA_FRANCO_SUIZO_ISO_LABEL = "Franco Suizo";
const MONEDA_YUAN_CHINO_ISO_LABEL = "Yuan Chino";
const MONEDA_DERECHO_ESPECIAL_GIRO_ISO_LABEL = "Derecho Especial de Giro";
const MONEDA_CORONA_DANESA_ISO_LABEL = "Corona Danesa";
const MONEDA_LIBRA_ESTERLINA_ISO_LABEL = "Libra Esterlina";
const MONEDA_YEN_JAPONES_ISO_LABEL = "Yen Japonés";
const MONEDA_CORONA_NORUEGA_ISO_LABEL = "Corona Noruega";
const MONEDA_LIBRA_ESCOCESA_ISO_LABEL = "Libra Escocesa";
const MONEDA_CORONA_SUECA_ISO_LABEL = "Corona Sueca";
const MONEDA_BOLIVAR_FUERTE_VENEZOLANO_ISO_LABEL = "Bolívar Fuerte Venezolano";
const MONEDA_GURDA_HAITIANA_ISO_LABEL = "Gurda Haitiana";

const CODIGO_MODIFICACION_ANULA_NCF_MODIFICADO = 1;
const CODIGO_MODIFICACION_CORRIGE_TEXTO = 2;
const CODIGO_MODIFICACION_CORRIGE_MONTO = 3;
const CODIGO_MODIFICACION_REMPLAZO_NCF_CONTINGENCIA = 4;
const CODIGO_MODIFICACION_REFERENCIA_FACTURA_CONSUMO_ELECTRONICA = 5;
const CODIGO_MODIFICACION_ANULA_NCF_MODIFICADO_LABEL = "Anulación total";
const CODIGO_MODIFICACION_CORRIGE_TEXTO_LABEL = "Corrección Texto";
const CODIGO_MODIFICACION_CORRIGE_MONTO_LABEL = "Corrección montos";
const CODIGO_MODIFICACION_REMPLAZO_NCF_CONTINGENCIA_LABEL = "Reemplazo NCF emitido en contingencia";
const CODIGO_MODIFICACION_REFERENCIA_FACTURA_CONSUMO_ELECTRONICA_LABEL = "Referenciar Factura de Consumo Electrónica";

export const TIPO_DESCUENTO_RECARGO_MONTO = "$";
export const TIPO_DESCUENTO_RECARGO_PORCENTAJE = "%";
const TIPO_DESCUENTO_RECARGO_MONTO_LABEL = "Monto";
const TIPO_DESCUENTO_RECARGO_PORCENTAJE_LABEL = "Porcentaje";

export class eCF {
  static get INDICADORES_FACTURACION() {
    return [
      {
        value: INDICADOR_FACTURACION_NO_FACTURABLE,
        label: INDICADOR_FACTURACION_NO_FACTURABLE_LABEL
      },
      {
        value: INDICADOR_FACTURACION_ITBIS_TASA_1,
        label: INDICADOR_FACTURACION_ITBIS_TASA_1_LABEL
      },
      {
        value: INDICADOR_FACTURACION_ITBIS_TASA_2,
        label: INDICADOR_FACTURACION_ITBIS_TASA_2_LABEL
      },
      {
        value: INDICADOR_FACTURACION_ITBIS_TASA_3,
        label: INDICADOR_FACTURACION_ITBIS_TASA_3_LABEL
      },
      {
        value: INDICADOR_FACTURACION_ITBIS_EXENTO,
        label: INDICADOR_FACTURACION_ITBIS_EXENTO_LABEL
      }
    ]
  };

  static get INDICADOR_BIEN_SERVICIO() {
    return [
      {
        value: ITEM_INDICADOR_BIEN,
        label: ITEM_INDICADOR_BIEN_LABEL
      },
      {
        value: ITEM_INDICADOR_SERVICIO,
        label: ITEM_INDICADOR_SERVICIO_LABEL
      }
    ]
  };

  static get ESTATUS_COMPROBANTE_ACEPTADOS() {
    return [
      {
        value: ESTATUS_COMPROBANTE_ACEPTADO,
        label: ESTATUS_COMPROBANTE_ACEPTADO_LABEL
      },
      {
        value: ESTATUS_COMPROBANTE_ACEPTADO_CONDICIONAL,
        label: ESTATUS_COMPROBANTE_ACEPTADO_CONDICIONAL_LABEL
      }
    ]
  };

  static get TIPOS_COMPROBANTES() {
    return [
      {
        value: TIPO_COMPROBANTE_FACTURA_CREDITO_FISCAL,
        label: TIPO_COMPROBANTE_FACTURA_CREDITO_FISCAL_LABEL
      },
      {
        value: TIPO_COMPROBANTE_FACTURA_CONSUMO,
        label: TIPO_COMPROBANTE_FACTURA_CONSUMO_LABEL
      },
      {
        value: TIPO_COMPROBANTE_NOTA_DEBITO,
        label: TIPO_COMPROBANTE_NOTA_DEBITO_LABEL
      },
      {
        value: TIPO_COMPROBANTE_NOTA_CREDITO,
        label: TIPO_COMPROBANTE_NOTA_CREDITO_LABEL
      },
      {
        value: TIPO_COMPROBANTE_COMPRAS,
        label: TIPO_COMPROBANTE_COMPRAS_LABEL
      },
      {
        value: TIPO_COMPROBANTE_GASTO_MENOR,
        label: TIPO_COMPROBANTE_GASTO_MENOR_LABEL
      },
      {
        value: TIPO_COMPROBANTE_REGIMEN_ESPECIAL,
        label: TIPO_COMPROBANTE_REGIMEN_ESPECIAL_LABEL
      },
      {
        value: TIPO_COMPROBANTE_GUBERNAMENTAL,
        label: TIPO_COMPROBANTE_GUBERNAMENTAL_LABEL
      },
      {
        value: TIPO_COMPROBANTE_EXPORTACIONES,
        label: TIPO_COMPROBANTE_EXPORTACIONES_LABEL
      },
      {
        value: TIPO_COMPROBANTE_PAGOS_EXTERIOR,
        label: TIPO_COMPROBANTE_PAGOS_EXTERIOR_LABEL
      }
    ]
  };

  static get TIPOS_INGRESOS() {
    return [
      {
        value: TIPO_INGRESOS_OPERACIONES,
        label: TIPO_INGRESOS_OPERACIONES_LABEL
      },
      {
        value: TIPO_INGRESOS_FINANCIEROS,
        label: TIPO_INGRESOS_FINANCIEROS_LABEL
      },
      {
        value: TIPO_INGRESOS_EXTRAORDINARIOS,
        label: TIPO_INGRESOS_EXTRAORDINARIOS_LABEL
      },
      {
        value: TIPO_INGRESOS_ARRENDAMIENTOS,
        label: TIPO_INGRESOS_ARRENDAMIENTOS_LABEL
      },
      {
        value: TIPO_INGRESOS_VENTA_ACTIVO,
        label: TIPO_INGRESOS_VENTA_ACTIVO_LABEL
      },
      {
        value: TIPO_INGRESOS_OTROS,
        label: TIPO_INGRESOS_OTROS_LABEL
      }
    ]
  };

  static get TIPOS_PAGOS() {
    return [
      {
        value: TIPO_PAGO_CONTADO,
        label: TIPO_PAGO_CONTADO_LABEL
      },
      {
        value: TIPO_PAGO_CREDITO,
        label: TIPO_PAGO_CREDITO_LABEL
      },
      {
        value: TIPO_PAGO_GRATUITO,
        label: TIPO_PAGO_GRATUITO_LABEL
      }
    ]
  };

  static get MONEDAS() {
    return [
      {
        value: MONEDA_PESO_DOMINICANO_ISO,
        label: MONEDA_PESO_DOMINICANO_ISO_LABEL
      },
      {
        value: MONEDA_DOLAR_ISO,
        label: MONEDA_DOLAR_ISO_LABEL
      },
      {
        value: MONEDA_EURO_ISO,
        label: MONEDA_EURO_ISO_LABEL
      },
      {
        value: MONEDA_PESO_MEXICANO_ISO,
        label: MONEDA_PESO_MEXICANO_ISO_LABEL
      },
      {
        value: MONEDA_PESO_COLOMBIANO_ISO,
        label: MONEDA_PESO_COLOMBIANO_ISO_LABEL
      },
      {
        value: MONEDA_REAL_BRASILENO_ISO,
        label: MONEDA_REAL_BRASILENO_ISO_LABEL
      },
      {
        value: MONEDA_DOLAR_CANADIENSE_ISO,
        label: MONEDA_DOLAR_CANADIENSE_ISO_LABEL
      },
      {
        value: MONEDA_FRANCO_SUIZO_ISO,
        label: MONEDA_FRANCO_SUIZO_ISO_LABEL
      },
      {
        value: MONEDA_YUAN_CHINO_ISO,
        label: MONEDA_YUAN_CHINO_ISO_LABEL
      },
      {
        value: MONEDA_DERECHO_ESPECIAL_GIRO_ISO,
        label: MONEDA_DERECHO_ESPECIAL_GIRO_ISO_LABEL
      },
      {
        value: MONEDA_CORONA_DANESA_ISO,
        label: MONEDA_CORONA_DANESA_ISO_LABEL
      },
      {
        value: MONEDA_LIBRA_ESTERLINA_ISO,
        label: MONEDA_LIBRA_ESTERLINA_ISO_LABEL
      },
      {
        value: MONEDA_YEN_JAPONES_ISO,
        label: MONEDA_YEN_JAPONES_ISO_LABEL
      },
      {
        value: MONEDA_CORONA_NORUEGA_ISO,
        label: MONEDA_CORONA_NORUEGA_ISO_LABEL
      },
      {
        value: MONEDA_LIBRA_ESCOCESA_ISO,
        label: MONEDA_LIBRA_ESCOCESA_ISO_LABEL
      },
      {
        value: MONEDA_CORONA_SUECA_ISO,
        label: MONEDA_CORONA_SUECA_ISO_LABEL
      },
      {
        value: MONEDA_BOLIVAR_FUERTE_VENEZOLANO_ISO,
        label: MONEDA_BOLIVAR_FUERTE_VENEZOLANO_ISO_LABEL
      },
      {
        value: MONEDA_GURDA_HAITIANA_ISO,
        label: MONEDA_GURDA_HAITIANA_ISO_LABEL
      }
    ];
  };

  static get CODIGOS_MODIFICACION() {
    return [
      {
        value: CODIGO_MODIFICACION_ANULA_NCF_MODIFICADO,
        label: CODIGO_MODIFICACION_ANULA_NCF_MODIFICADO_LABEL
      },
      {
        value: CODIGO_MODIFICACION_CORRIGE_TEXTO,
        label: CODIGO_MODIFICACION_CORRIGE_TEXTO_LABEL
      },
      {
        value: CODIGO_MODIFICACION_CORRIGE_MONTO,
        label: CODIGO_MODIFICACION_CORRIGE_MONTO_LABEL
      },
      {
        value: CODIGO_MODIFICACION_REMPLAZO_NCF_CONTINGENCIA,
        label: CODIGO_MODIFICACION_REMPLAZO_NCF_CONTINGENCIA_LABEL
      }
    ];
  };

  static get TIPOS_DESCUENTOS() {
    return [
      {
        value: TIPO_DESCUENTO_RECARGO_MONTO,
        label: TIPO_DESCUENTO_RECARGO_MONTO_LABEL
      },
      {
        value: TIPO_DESCUENTO_RECARGO_PORCENTAJE,
        label: TIPO_DESCUENTO_RECARGO_PORCENTAJE_LABEL
      }
    ];
  };
};